<template>
  <ULink
    to="#main"
    :active="true"
    class="absolute bg-white overflow-hidden top-auto left-[-10000px] p-2 w-px h-px focus:top-0 focus:left-0 focus:w-full focus:h-auto focus:z-[100000000] text-center font-bold"
  >
    {{ t('accessibility.skipLink') }}
  </ULink>
</template>
